module.exports = __webpack_public_path__ + "static/img/lflkData.081ad29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lflkData.png
// module id = nMYN
// module chunks = 1